import type { QuestionnaireResponse } from '@medplum/fhirtypes';

/**
 * Medplum rejects POST bodies that include server-managed meta/version fields from a prior read
 * or from the in-memory form state. Strip those for **create**; keep tags we set (e.g. appointment id).
 */
export function sanitizeQuestionnaireResponseForCreate(
  qr: QuestionnaireResponse,
): QuestionnaireResponse {
  const { id, implicitRules, contained, meta, ...rest } = qr;
  void id;
  void implicitRules;
  void contained;
  const cleanMeta =
    meta &&
    ({
      tag: meta.tag,
      profile: meta.profile,
      security: meta.security,
      accounts: meta.accounts,
    } as QuestionnaireResponse['meta']);

  return {
    ...rest,
    meta: cleanMeta,
  };
}
